module.exports = __webpack_public_path__ + "static/media/Icons-Logo-VMA_Blu.647fc2c5.svg";